export default "__VITE_ASSET__D0fF3esl__"